import React from "react";
import { Row, Col, Grid } from "react-bootstrap";
import get from "lodash/get";
import { AlbumArt } from "../../lib/album-art";
import "./show_page_wrapper.scss";
import { Glyphicon } from "react-bootstrap";
import Divider from "../../lib/divider";
import { If } from "react-extras";
import { Link } from "react-router-dom";

const ShowPageWrapper = props => {
  const { title, subtitle, eyebrow = null } = props;

  const imageURL = get(props, "show.imageURL");
  return (
    <div className={"show-page-wrapper"}>
      <Grid fluid>
        <Row>
          <Col xs={12} md={1}>
            <Link
              to={props.backLink || `/shows/${get(props, "show.uuid")}`}
              className={"bold back-link"}>
              <Glyphicon glyph={"chevron-left"} />
              <span>Back</span>
            </Link>
          </Col>
        </Row>
        {props.preHeader && props.preHeader()}
        <Row>
          <Col xs={12} md={4}>
            {imageURL && <AlbumArt className={"margin-bottom--large album-art"} src={imageURL} />}
            {props.underAlbumContent && props.underAlbumContent()}
          </Col>
          <Col xs={12} md={8}>
            {eyebrow}
            <div className={"flex-row-container align-center"}>
              <h1 className={"no-margin"}>{title}</h1>
              <If condition={!!props.rightLink}>
                <>
                  <div className="flex-1" />
                  {props.rightLink && props.rightLink()}
                </>
              </If>
            </div>
            {subtitle && <div className="margin-top--small">{subtitle}</div>}

            <Divider smallMargin />
            {props.children}
          </Col>
        </Row>
        {props.postBody && props.postBody()}
      </Grid>
    </div>
  );
};

export default ShowPageWrapper;
